import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export type CreateDraftPayload = {
    projectName: string;
    templateId: string;

    content?: { html: string; css: string; blocks?: any[] };

    meta?: Record<string, any>;
};

export type DraftDto = {
    id: string;
    projectName: string;
    templateId: string;
    content: { html: string; css: string; blocks?: any[] };
    documentHtml: string;
    patchVersion: number;
    meta: any;
    createdAt: string;
    updatedAt: string;
};

export type CreateDraftResponse = {
    status: number;
    data: DraftDto;
};

export const createDraft = async (payload: CreateDraftPayload): Promise<DraftDto> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const { data } = await gatewayPageBuilder.post<CreateDraftResponse>(
        "page-builder/drafts/create",
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
